import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/home/index.vue'
import LoginView from '../views/login/index.vue'


const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/login',
      name: 'login',
      component: LoginView,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/cczl',
      name: 'cczl',
      component: () => import('../views/cczl/index.vue'),
      meta: {
        bg: '',
        requiresAuth: true,
        allowedRoles: ['all', 'cczl']
      }
    },
    {
      path: '/ssc',
      name: 'ssc',
      component: () => import('../views/ssc/index.vue'),
      meta: {
        bg: '',
        requiresAuth: true,
        allowedRoles: ['all', 'ssc']
      }
    },
    {
      path: '/road',
      name: 'road',
      component: () => import('../views/road/index.vue'),
      meta: {
        bg: new URL('../assets/taber/db-btn-03.png', import.meta.url).href,
        requiresAuth: true,
        allowedRoles: ['all', 'road']
      }
    },
    {
      path: '/car',
      name: 'car',
      component: () => import('../views/car/index.vue'),
      meta: {
        bg: new URL('../assets/taber/db-btn-02.png', import.meta.url).href,
        requiresAuth: true,
        allowedRoles: ['all', 'car']
      }
    },
    {
      path: '/taxi',
      name: 'taxi',
      component: () => import('../views/taxi/index.vue'),
      meta: {
        bg: new URL('../assets/taber/db-btn-02.png', import.meta.url).href,
        requiresAuth: true,
        allowedRoles: ['all', 'taxi']
      }
    },
    {
      path: '/bus',
      name: 'bus',
      component: () => import('../views/bus/index.vue'),
      meta: {
        bg: new URL('../assets/taber/db-btn-02.png', import.meta.url).href,
        requiresAuth: true,
        allowedRoles: ['all', 'bus']
      }
    },
    {
      path: '/robot',
      name: 'robot',
      component: () => import('../views/robot/index.vue'),
      meta: {
        bg: new URL('../assets/taber/db-btn-02.png', import.meta.url).href,
        requiresAuth: true,
        allowedRoles: ['all', 'robot']
      }
    },
    {
      path: '/cloud',
      name: 'cloud',
      component: () => import('../views/cloud/index.vue'),
      meta: {
        bg: new URL('../assets/taber/db-btn-05.png', import.meta.url).href,
        requiresAuth: true,
        allowedRoles: ['all', 'cloud']
      }
    },
    {
      path: '/',
      name: 'home',
      component: HomeView,
      meta: {
        bg: new URL('../assets/taber/db-btn-01.png', import.meta.url).href,
        requiresAuth: true,
        allowedRoles: ['all']
      }
    },
  ],
})

router.beforeEach((to, from, next) => {
  import('../utils/request').then(({ checkAuth, getRoles }) => {
    if (to.meta.requiresAuth) {
      if (!checkAuth()) {
        return next('/login')
      }
      
      const userRoles = getRoles()
      const allowedRoles = to.meta.allowedRoles as string[]
      
      if (!allowedRoles.includes(userRoles || '')) {
        return next('/login')
      }
    }
    
    next()
  })
})

export default router
